<template>
  <div id="tenants-slim-list">
    <div v-if="minimum && searchable" class="tenants-slim-search mb-2">
      <vs-input
        v-model="searchTerm"
        class="w-full"
        :placeholder="searchPlaceholder"
      />
      <p class="tenants-slim-search-info mb-0 mt-1">
        Exibindo {{ visibleTenants.length }} de {{ baseVisibleTenants.length }} dashes
      </p>
    </div>

    <div v-if="!minimum">
      <vs-table
        search
        pagination
        ref="table"
        :data="visibleTenants"
        :stripe="stripe"
        :max-items="itemsPerPage"
        noDataText="Sem dados disponíveis"
      >
        <template slot="header">
          <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4" v-if="modifyItensPerPage">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">
              {{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
              {{ visibleTenants.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : visibleTenants.length }} de {{ queriedItems }}
            </span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="itemsPerPage=4">
                <span>4</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=10">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=15">
                <span>15</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage=20">
                <span>20</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </template>

        <template slot="thead">
          <vs-th v-if="checkbox" style="width: 50px;">
            <vs-checkbox v-model="selectedAll" :vs-value="true"/>
          </vs-th>
          <vs-th sort-key="fqdn">
            Nome
          </vs-th>
        </template>

        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td v-if="checkbox">
                <vs-checkbox v-model="internalSelecteds" :vs-value="tr.id"/>
              </vs-td>
              <vs-td>
                <p class="product-name font-medium truncate">{{ parseName(tr.fqdn) }}</p>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
    <div v-else>
      <div class="tenants-slim-minimum-list" v-if="visibleTenants.length">
        <div :key="indextr" v-for="(tr, indextr) in pagedVisibleTenants" class="flex mb-2">
          <vs-td>
            <vs-checkbox v-model="internalSelecteds" :vs-value="tr.id" :title="parseName(tr.fqdn)">
              <div class="flex">
                <p class="align-self-center">{{ parseName(tr.fqdn) }}</p>
              </div>
            </vs-checkbox>
          </vs-td>
        </div>
      </div>
      <div class="tenants-slim-pagination mt-2" v-if="minimumTotalPages > 1">
        <vs-pagination
          :total="minimumTotalPages"
          v-model="minimumPage"
          :max="7"
        />
      </div>
      <p v-if="baseVisibleTenants.length === 0" class="tenants-slim-empty-hint mb-0 mt-1">
        Nenhuma dash ativa disponível.
      </p>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    props: {
      checkbox: {
        type: Boolean,
        required: false
      },
      selecteds: {
        required: false,
        default(){ return [] },
        validator: prop => typeof prop === 'object' || prop === null
      },
      minimum: {
        type: Boolean,
        required: false,
        default(){ return false }
      },
      stripe: {
        type: Boolean,
        required: false,
        default(){ return true }
      },
      modifyItensPerPage: {
        type: Boolean,
        required: false,
        default(){ return true }
      },
      onlyActives: {
        type: Boolean,
        required: false,
        default(){ return false }
      },
      searchable: {
        type: Boolean,
        required: false,
        default(){ return false }
      },
      searchPlaceholder: {
        type: String,
        required: false,
        default(){ return 'Filtrar dash por nome' }
      },
      minimumItemsPerPage: {
        type: Number,
        required: false,
        default(){ return 5 }
      },
    },
    data() {
      return {
        isMounted: false,
        selectedAll: false,
        internalSelecteds: [],
        itemsPerPage: 4,
        minimumPage: 1,
        searchTerm: '',
        settings: {
          maxScrollbarLength: 60,
          wheelSpeed: .60
        }
      }
    },
    computed: {
      ...mapGetters(['token', 'tenants']),
      baseVisibleTenants() {
        if (!this.onlyActives) return this.tenants;
        return this.tenants.filter(tenant => !tenant || !tenant.deleted_at);
      },
      normalizedSearchTerm() {
        return this.normalizeTenantSearch(this.searchTerm);
      },
      visibleTenants() {
        if (!this.normalizedSearchTerm) {
          return this.baseVisibleTenants;
        }

        return this.baseVisibleTenants.filter((tenant) => this.tenantMatchesSearch(tenant));
      },
      currentPage() {
        if (this.isMounted) return this.$refs.table.currentx
        return 0
      },
      queriedItems() {
        return this.$refs.table ? this.$refs.table.queriedResults.length : this.visibleTenants.length
      },
      parsedMinimumItemsPerPage() {
        const parsed = Number(this.minimumItemsPerPage);
        if (Number.isNaN(parsed) || parsed <= 0) {
          return 5;
        }
        return Math.floor(parsed);
      },
      minimumTotalPages() {
        if (!this.visibleTenants.length) {
          return 0;
        }

        return Math.ceil(this.visibleTenants.length / this.parsedMinimumItemsPerPage);
      },
      pagedVisibleTenants() {
        if (!this.minimum || this.parsedMinimumItemsPerPage <= 0) {
          return this.visibleTenants;
        }

        const page = this.minimumPage > 0 ? this.minimumPage : 1;
        const start = (page - 1) * this.parsedMinimumItemsPerPage;
        const end = start + this.parsedMinimumItemsPerPage;
        return this.visibleTenants.slice(start, end);
      }
    },
    methods:{
      parseName(fqdn){
        return fqdn ? fqdn.split(".")[0] : null;
      },
      normalizeTenantSearch(value) {
        return `${value || ''}`.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
      },
      tenantMatchesSearch(tenant) {
        const query = this.normalizedSearchTerm;
        if (!query) { return true; }
        const name = this.parseName(tenant && tenant.fqdn) || '';
        return this.normalizeTenantSearch(name).includes(query);
      },
      sameArrayAsSet(first, second) {
        if (!Array.isArray(first) || !Array.isArray(second)) {
          return false;
        }

        if (first.length !== second.length) {
          return false;
        }

        const set = new Set(first);
        return second.every((item) => set.has(item));
      },
      syncSelectedAllFlag() {
        const visibleIds = this.visibleTenants.map((tenant) => tenant.id);

        if (visibleIds.length === 0) {
          this.selectedAll = false;
          return;
        }

        this.selectedAll = this.sameArrayAsSet(this.internalSelecteds, visibleIds);
      }
    },
    watch: {
      visibleTenants() {
        if (this.isMounted && this.$refs.table) {
          this.$refs.table.currentx = 1
        }
      },
      selecteds: {
        immediate: true,
        handler(value) {
          const parsed = Array.isArray(value) ? [...new Set(value)] : [];

          if (!this.sameArrayAsSet(parsed, this.internalSelecteds)) {
            this.internalSelecteds = parsed;
          }

          this.syncSelectedAllFlag();
        },
      },
      internalSelecteds(value) {
        const parsed = Array.isArray(value) ? [...new Set(value)] : [];

        if (!this.sameArrayAsSet(parsed, value)) {
          this.internalSelecteds = parsed;
          return;
        }

        const propParsed = Array.isArray(this.selecteds) ? [...new Set(this.selecteds)] : [];
        if (this.sameArrayAsSet(parsed, propParsed)) {
          this.syncSelectedAllFlag();
          return;
        }

        this.$emit("selectedTenant", parsed);
        this.$emit("update:selecteds", parsed);
        this.syncSelectedAllFlag();
      },
      selectedAll(value){
        const visibleIds = this.visibleTenants.map((tenant) => tenant.id);

        if (value){
          if (!this.sameArrayAsSet(this.internalSelecteds, visibleIds)) {
            this.internalSelecteds = visibleIds;
          }
          return;
        }

        if (visibleIds.length > 0 && this.sameArrayAsSet(this.internalSelecteds, visibleIds)) {
          this.internalSelecteds = [];
        }
      },
      visibleTenants() {
        if (this.minimumPage !== 1) {
          this.minimumPage = 1;
        }

        this.syncSelectedAllFlag();
      },
      minimumTotalPages(value) {
        if (value === 0) {
          this.minimumPage = 1;
          return;
        }

        if (this.minimumPage > value) {
          this.minimumPage = value;
        }
      }
    },
    mounted() {
      this.isMounted = true;
    },
    created() {
      if ( !this.tenants.length ) this.$store.dispatch('getAllTenants', { token: this.token })
    }
  }
</script>

<style scoped>
.tenants-slim-search-info {
  font-size: 12px;
  color: #64748b;
}

.tenants-slim-minimum-list {
  max-height: 320px;
  overflow-y: auto;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 8px;
}

.tenants-slim-empty {
  font-size: 12px;
  font-weight: 600;
  color: #475569;
}

.tenants-slim-empty-hint {
  font-size: 11px;
  color: #64748b;
}
</style>
